import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { FeaturesModule } from './features/features.module';
import { TokenInterceptor } from './core/interceptors/auth.interceptor';
import { BaseLoaderComponent } from './shared/components/base-loader/base-loader.component';
import { CommaSeperatorPipe } from './shared/components/form_fields/partner-code/partner-code.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FeaturesModule,
    BaseLoaderComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    CommaSeperatorPipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
